import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import GiftIcon from '@wix/da-ds/pkg/Icons/24x24/Gift';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './Gifted.scss';
const Gifted = ()=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center",
        justifyContent: "center",
        className: s['root'],
        gap: 2
    }, /*#__PURE__*/ React.createElement(GiftIcon, {
        disableDefaultColors: true,
        size: IconSize.TINY
    }), t('sidebar.exclusives.currentOwner.gifted'));
};
Gifted.displayName = 'Gifted';
export default Gifted;

//# sourceMappingURL=Gifted.js.map